import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Wrap,
  WrapItem,
  Box,
} from "@chakra-ui/react";
import baseUrl from "../vars";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { useEffect } from "react";
import ModalEditRole from "./modal_edit_role";
import { authFetch } from "../auth/auth";

const PERMISSION_CATEGORIES = [
  "оплаты",
  "счета",
  "открытая выручка",
  "открытая прибыль",
  "форма",
  "отчёты",
  "прибыль",
  "потенциал",
  "права",
  "панель мопов",
  "карточки счетов",
  "заказ поставщику",
  "просроченная дз"
];

const CATEGORY_MAP = {
  "оплаты": ["get pays all", "get pays in departament", "get pays self"],
  "счета": ["get orders all", "get orders in departament", "get orders self"],
  "форма": ["get departaments", "get workers", "set fired"],
  "отчёты": ["get reports all", "get reports in departament", "get reports self"],
  "прибыль": ["add profits", "get profits all", "get profits in departament", "get profits self"],
  "потенциал": ["get potential all", "get potential in departament", "get potential self"],
  "права": ["add permissions", "delete permissions", "edit roles", "edit users","export excel", "get logs", "get staff"],
  "открытая выручка": ["get open rev all", "get open rev in departament", "get open rev self"],
  "открытая прибыль": ["get open profit all", "get open profit in departament", "get open profit self"],
  "панель мопов": ["get mops all", "get mops in departament", "get mops self"],
  "карточки счетов": ["get pdz all", "get pdz in departament", "get pdz self"],
  "заказ поставщику": ["get order_suppliers all", "get order_suppliers in departament", "get order_suppliers self"],
  "просроченная дз": ["get overdue all", "get overdue in departament", "get overdue self"],
};

const PERMISSION_TRANSLATIONS = {
  "add permissions": "Добавление прав",
  "add profits": "Добавление отчётов о прибыли",
  "delete permissions": "Удаление прав",
  "edit roles": "Редактирование роли",
  "edit users": "Редактирование пользователя",
  "get departaments": "Получение отделов",
  "get orders all": "Получение всех счетов",
  "get orders in departament": "Получение счетов в отделе",
  "get orders self": "Получение своих счетов",
  "get pays all": "Получение всех оплат",
  "get pays in departament": "Получение оплат в отделе",
  "get pays self": "Получение своих оплат",
  "get potential all": "Получение всех потенциалов",
  "get potential in departament": "Получение потенциалов в департаменте",
  "get potential self": "Получение своих потенциалов",
  "get profits all": "Получение всей прибыли",
  "get profits in departament": "Получение прибыли в департаменте",
  "get profits self": "Получение своей прибыли",
  "get reports all": "Получение всех отчётов",
  "get reports in departament": "Получение отчётов в департаменте",
  "get reports self": "Получение своих отчётов",
  "get workers": "Получение сотрудников",
  "set fired": "Отмечать уволенными",
  "export excel": "Экспорт в эксель",
  "get logs": "получать логи",
  "get open rev all": "Получение всей открытой выручки",
  "get open rev self": "Получение своей открытой выручки",
  "get open rev in departament": "Получение открытой выручки в департаменте",
  "get open profit all": "Получение всей открытой прибыли",
  "get open profit self": "Получение своей открытой прибыли",
  "get open profit in departament": "Получение открытой прибыли в департаменте",
  "get staff": "Получение отчета Сотрудники",
  "get mops all": "Вся Панель МОПов",
  "get mops in departament": "Панель МОПов за департамент",
  "get mops self": "Панель МОПов за себя",
  "get pdz all": "Получение всех карточек счетов",
  "get pdz in departament": "Получение карточек счетов в департаменте",
  "get pdz self": "Получение своих карточек счетов",
  "get order_suppliers all": "Получение всех заказов поставщикам",
  "get order_suppliers in departament": "Получение заказов поставщикам в департаменте",
  "get order_suppliers self": "Получение своих заказов поставщикам",
  "get overdue all": "Получение всей просроченной ДЗ",
  "get overdue in departament": "Получение просроченной ДЗ в департаменте",
  "get overdue self": "Получение своей просроченной ДЗ"
};
const TableControl = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllRoles();
  }, []);

  useEffect(() => {
    const getAllPermissions = async () => {
      const response = await authFetch(`${baseUrl}/api/permissions`, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${pageStore.token}`,
        },
      });
      const result = await response.json();
      pageStore.updatePermissions(result);
    };
    getAllPermissions();
  }, []);
  
  const getPermissionsForCategory = (permissions, category) => {
    return permissions.filter(perm => 
      CATEGORY_MAP[category].includes(perm.name)
    );
  }

  return (
    <Table 
      variant="simple" 
      colorScheme="black"
      size="sm"
      sx={{
        "th, td": {
          py: 2,
          px: 2,
        }
      }}
    >
      <Thead>
        <Tr>
          <Th color={"white"} width="50px">ID</Th>
          <Th color={"white"} width="150px">Роль</Th>
          {PERMISSION_CATEGORIES.map(category => (
            <Th 
              key={category} 
              color={"white"}
              minWidth="150px"
            >
              {category}
            </Th>
          ))}
          <Th color={"white"} width="100px">Действия</Th>
        </Tr>
      </Thead>
      <Tbody color={"white"}>
        {pageStore.roles
          ?.filter((item) => item?.name != "")
          ?.map((role) => (
            <Tr key={role?.id}>
              <Td color={"white"}>{role?.id}</Td>
              <Td fontWeight="semibold" color={"white"}>
                {role?.name || "(не указано)"}
              </Td>
              {/* Столбцы с разрешениями по категориям */}
              {PERMISSION_CATEGORIES.map(category => {
                const categoryPermissions = getPermissionsForCategory(
                  role.permissions || [],
                  category
                );
                
                return (
                  <Td 
                    key={category}
                    verticalAlign="top"
                  >
                    {categoryPermissions.length > 0 ? (
                      <Wrap spacing={1} shouldWrapChildren>
                        {categoryPermissions.map((perm) => (
                          <WrapItem key={perm?.id} w="100%">
                            <Box
                              bg="rgba(150, 212, 224, 1)"
                              borderRadius="15px"
                              border={"2px"}
                              color={"black"}
                              borderColor="rgba(150, 212, 224, 1)"
                              px={2}
                              py={1}
                              whiteSpace="normal"
                              textAlign="center"
                              fontSize="sm"
                              w="100%"
                              mb={1}
                            >
                              {PERMISSION_TRANSLATIONS[perm.name] || perm.name}
                            </Box>
                          </WrapItem>
                        ))}
                      </Wrap>
                    ) : (
                      <Box
                        color={"black"}
                        bg="rgba(255, 170, 172, 1)"
                        borderRadius="15px"
                        border={"2px"}
                        borderColor="rgba(255, 170, 172, 1)"
                        px={2}
                        py={1}
                        textAlign="center"
                        fontSize="sm"
                      >
                        Нет
                      </Box>
                    )}
                  </Td>
                );
              })}
              
              <Td>
                <ModalEditRole obj={role} />
              </Td>
            </Tr>
          ))}
      </Tbody>
    </Table>
  );
});

export default TableControl;
